<div class="plate" [style]="style"></div>
